import { Controller } from "@hotwired/stimulus";
import { Target, Targets, TypedController } from "@vytant/stimulus-decorators";

@TypedController
export default class extends Controller {
  @Target selectTarget!: HTMLSelectElement;
  @Targets tabTargets!: HTMLElement[];

  connect() {
    this.switch();
  }

  switch() {
    const selectedTabName = this.selectTarget.value;

    this.tabTargets.forEach((tab) => {
      if (tab.dataset.tabName === selectedTabName) {
        tab.classList.remove("hidden");
      } else {
        tab.classList.add("hidden");
      }
    });
  }
}
